import * as React from 'react';

function Loading() {
  return (
    <div  className="loaderContainer">
      <div className="loader"></div>
    </div>
  );
}

export { Loading }